import React, {ReactNode, useCallback} from 'react';
import {MarkerCluster} from 'leaflet';
import {
    clusterPointsGroupCreateFunctionSingleVoyage
} from "@containers/singleVoyage/containers/points/helpers/buildPointClusterIcon";
import '../styles.scss'
import LeafletCluster from "@ui/leafletCustom/leafletCluster/LeafletCluster";

interface IProps {
    children: ReactNode,
    hasRerenderOnChangeChildren?:boolean
}

const PointsGroupClusterSingleVoyage = ({children,hasRerenderOnChangeChildren}: IProps) => {

    const createClusterCustomIcon = useCallback((cluster: MarkerCluster) => {
        return clusterPointsGroupCreateFunctionSingleVoyage({
            cluster,
        })
    }, [])

    return (
        <LeafletCluster
            spiderfyOnClick={false}
            iconCreateFunction={createClusterCustomIcon}
            disableClusteringAtZoom={19}
            hasRerenderOnChangeChildren={hasRerenderOnChangeChildren}
        >
            {children}
        </LeafletCluster>
    );
};

export default PointsGroupClusterSingleVoyage;
